<template>
    <div class="missionBox">
        <div class="missionBoxWidth">
            <div :style="{ backgroundImage: `url('${item.cover}')`, }" v-for="item in dataInfo.list" :key="item.id"
                class="missionItem">
                <div class="title">{{ item.title }}</div>
                <div class="contentText">{{ item.desc }}</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        dataInfo: {
            type: Object,
            default: () => {
                return {
                    is_show: 0,
                    list: [],
                    moduleTitle: '',
                }
            },
        },
    },
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.missionBox {
    background: #FFFFFF;
    padding-bottom: 36px;
    padding-top: 90px;

    .missionBoxWidth {
        width: 1200px;
        margin: auto;

        .missionItem {
            min-height: 180px;
            margin-top: 18px;
            position: relative;
            background-repeat: no-repeat;
            background-size: auto 100%;
            background-position: center;

            .title {
                font-weight: 500;
                font-size: 32px;
                line-height: 32px;
                color: #000000;
                text-align: center;
                font-weight: bold;
            }

            .contentText {
                font-size: 24px;
                color: #000000;
                line-height: 27px;
                text-align: center;
                margin-top: 34px;
            }

        }
    }
}

@media screen and (max-width:1200px) {
    .missionBox {
        background: #FFFFFF;
        padding-bottom: 36px;
        padding-top: 90px;

        .missionBoxWidth {
            width: 100%;
            
        }
    }
}
</style>